module.exports = __webpack_public_path__ + "static/media/biocertica-logo-black.4570f27d.svg";